<script>
	import options from './InStockLabel.options'
	export default options
</script>

<template>

	<div class="nlx-product-spot__stock-status">
		<template v-if="inStock == 0">
				<span class="nlx-product-spot__stock-status-icon"></span>
				<span>{{formatted}}</span>
		</template>
		<template v-else-if="inStock == 1">
				<span class="nlx-product-spot__stock-status-icon nlx-product-spot__stock-status-icon--limited-stock"></span>
				<span>{{formatted}}</span>
		</template>
		<template v-else-if="inStock == 2">
				<span class="nlx-product-spot__stock-status-icon nlx-product-spot__stock-status-icon--no-stock"></span>
				<span>{{formatted}}</span>
		</template>
		<template v-else-if="inStock == 3">
				<span class="nlx-product-spot__stock-status-icon nlx-product-spot__stock-status-icon--remote-warehouse"></span>
				<span>{{formatted}}</span>
		</template>
		<p class="nlx-product-spot__stock-status__text">
			
			<span>{{formattedAvailableDate}}</span>
		</p>
	</div>

</template>
